import { defineComponent as _defineComponent } from 'vue';
import { BLink } from "bootstrap-vue";
import { computed } from "vue";
import { hasDetails } from "@/api";
import { STATES } from "@/components/History/Content/model/states";
import { useDatasetStore } from "@/stores/datasetStore";
import {} from ".";
import DatasetActions from "./DatasetActions.vue";
import DatasetMiscInfo from "./DatasetMiscInfo.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetDetails',
    props: {
        id: null,
        writable: { type: Boolean, default: true },
        showHighlight: { type: Boolean, default: false },
        itemUrls: null
    },
    emits: ["toggleHighlights", "edit"],
    setup(__props, { emit }) {
        const props = __props;
        const datasetStore = useDatasetStore();
        const result = computed(() => datasetStore.getDataset(props.id));
        const isLoading = computed(() => datasetStore.isLoadingDataset(props.id));
        const stateText = computed(() => result.value && STATES[result.value.state] && STATES[result.value.state].text);
        function toggleHighlights() {
            emit("toggleHighlights");
        }
        return { __sfc: true, datasetStore, props, emit, result, isLoading, stateText, toggleHighlights, BLink, hasDetails, DatasetActions, DatasetMiscInfo };
    }
});
